module.exports = __webpack_public_path__ + "static/media/Acervo_identidade.137db1f1.jpg";